<template>
    <div>
        <div class="row mt-2" v-for="(data, index) in times">
            <div class="col-12">
                <el-time-picker
                    is-range
                    v-model="times[index]"
                    range-separator="To"
                    start-placeholder="Start time"
                    end-placeholder="End time"
                    format="HH:mm"
                    value-format="HH:mm"
                    size="mini"
                    :picker-options="{format: 'HH:mm'}"
                    style="width: calc(100% - 3.5rem) !important;">
                </el-time-picker>
                <base-button
                    size="sm"
                    icon
                    type="danger"
                    style=""
                    class="ml-2"
                    @click.native="times.splice(index,1)
                        ">
                    <font-awesome-icon :icon="['fal','trash']"></font-awesome-icon>

                </base-button>
            </div>


        </div>
        <div class="row">
            <div class="col-12">
                <base-button
                    size="sm"
                    icon
                    type="success"
                    @click="addTimes"
                >
                    <font-awesome-icon :icon="['fal','plus']"></font-awesome-icon>

                </base-button>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: "TimeconditionTimes",
    props: {
        initialValue: Array,
    },
    data() {
        return {
            times: this.initialValue,
        }
    },
    methods: {
        addTimes() {
            this.times.push([new Date().toTimeString().split(' ')[0], new Date().toTimeString().split(' ')[0]]);
        }
    },
    mounted() {
        if (this.initialValue === undefined) {
            this.times = [];
        } else {
            this.times = this.initialValue;

        }
    },
    watch: {
        times: {
            handler(value) {
                this.$emit('update', this.times);
            },
            deep: true
        }, initialValue: {
            handler(value) {
                this.times = this.initialValue;
            },
            deep: true
        },
    }
}
</script>

<style scoped>

</style>
